import { request } from '@luna/api';
import { getEnv } from '@luna/env';
import { createQueryString } from '@luna/router';
import type {
    ServiceRequestDefinitionsList,
    ServiceRequestDefinitionsListResponse,
} from '@api-client/products-webapi';

export const fetchAccountServiceOperations = async (
    productId: string,
): Promise<ServiceRequestDefinitionsList> => {
    const accountServiceOperationsQueryParams = createQueryString({
        productId,
    });
    const url = `${
        getEnv().prestoUrl
    }my/serviceRequests/definitions${accountServiceOperationsQueryParams}`;

    return request<ServiceRequestDefinitionsListResponse>(url);
};
